import React, { Component } from "react";
import "./CarView.css";
import { connect } from "react-redux";

import store from "../../store";
import { Route, Link, BrowserRouter as Router } from "react-router-dom";

import Button from "@material-ui/core/Button";
import { makeStyles, withStyles } from "@material-ui/core/styles";

import Paper from "@material-ui/core/Paper";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";

import CarViewDetail from "../CarViewDetail/CarViewDetail";

import CarViewCircles from "../CarViewCircles/CarViewCircles";

import CarViewTextDetail from "../CarViewTextDetail/CarViewTextDetail";

import { createMuiTheme } from "@material-ui/core/styles";
import green from "@material-ui/core/colors/green";
import CarGallery from "../CarGallery/CarGallery";
import { isMobile } from "react-device-detect";

const imgdir = process.env.REACT_APP_IMG_FOLDER;

const ColorButton = withStyles(theme => ({
  root: {
    fontFamily: "Arial",
    fontWeight: "bold",
    borderColor: green[500],
    backgroundColor: green[500],
    color: theme.palette.getContrastText(green[50]),
    color: green[50],
    borderRadius: 20,
    "&:hover": {
      backgroundColor: green[100],
      color: theme.palette.getContrastText(green[500]),
      color: green[700]
    }
  }
}))(Button);

const imgStyle = {
  width: "50%",
  height: "50%",
  display: "block",
  marginLeft: "auto",
  marginRight: "auto"
};

class CarView extends Component {
  constructor(props) {
    let selectedCar = JSON.parse(localStorage.getItem("selectedCar"));
    super(props);
    this.state = {
      car: selectedCar,
      images: [],
      image0: {
        src: imgdir + selectedCar.foto2,
        thumbnail: imgdir + selectedCar.foto2,
        thumbnailWidth: 320,
        thumbnailHeight: 174
      },
      image1: {
        src: imgdir + selectedCar.foto3,
        thumbnail: imgdir + selectedCar.foto3,
        thumbnailWidth: 320,
        thumbnailHeight: 174
      },
      image2: {
        src: imgdir + selectedCar.foto4,
        thumbnail: imgdir + selectedCar.foto4,
        thumbnailWidth: 320,
        thumbnailHeight: 174
      },
      image3: {
        src: imgdir + selectedCar.foto5,
        thumbnail: imgdir + selectedCar.foto5,
        thumbnailWidth: 320,
        thumbnailHeight: 174
      },
      image4: {
        src: imgdir + selectedCar.foto6,
        thumbnail: imgdir + selectedCar.foto6,
        thumbnailWidth: 320,
        thumbnailHeight: 174
      },
      image5: {
        src: imgdir + selectedCar.foto7,
        thumbnail: imgdir + selectedCar.foto7,
        thumbnailWidth: 320,
        thumbnailHeight: 174
      },
      image6: {
        src: imgdir + selectedCar.foto8,
        thumbnail: imgdir + selectedCar.foto8,
        thumbnailWidth: 320,
        thumbnailHeight: 174
      }
    };
  }
  componentDidMount() {
    if (store.getState().carsReducer.car != null) {
      this.setState(
        {
          car: store.getState().carsReducer.car
        },
        () => {
          localStorage.setItem("selectedCar", JSON.stringify(this.state.car));
        }
      );
    }
    this.setImages();
  }

  setImages = () => {
    this.setState({
      image0: {
        src: imgdir + this.state.car.foto2,
        thumbnail: imgdir + this.state.car.foto2,
        thumbnailWidth: 320,
        thumbnailHeight: 174
      },
      image1: {
        src: imgdir + this.state.car.foto3,
        thumbnail: imgdir + this.state.car.foto3,
        thumbnailWidth: 320,
        thumbnailHeight: 174
      },
      image2: {
        src: imgdir + this.state.car.foto4,
        thumbnail: imgdir + this.state.car.foto4,
        thumbnailWidth: 320,
        thumbnailHeight: 174
      },
      image3: {
        src: imgdir + this.state.car.foto5,
        thumbnail: imgdir + this.state.car.foto5,
        thumbnailWidth: 320,
        thumbnailHeight: 174
      },
      image4: {
        src: imgdir + this.state.car.foto6,
        thumbnail: imgdir + this.state.car.foto6,
        thumbnailWidth: 320,
        thumbnailHeight: 174
      },
      image5: {
        src: imgdir + this.state.car.foto7,
        thumbnail: imgdir + this.state.car.foto7,
        thumbnailWidth: 320,
        thumbnailHeight: 174
      },
      image6: {
        src: imgdir + this.state.car.foto8,
        thumbnail: imgdir + this.state.car.foto8,
        thumbnailWidth: 320,
        thumbnailHeight: 174
      },
      image7: {
        src: imgdir + this.state.car.foto9,
        thumbnail: imgdir + this.state.car.foto9,
        thumbnailWidth: 320,
        thumbnailHeight: 174
      }
    });
    console.log("IMAGEs" + this.state.image0.src);
  };

  handleReservar = selectedPat => {
    if (selectedPat !== 0) {
      this.setState(
        {
          car: {
            ...this.state.car,
            patentamiento: selectedPat
          }
        },
        () => {
          localStorage.setItem("selectedCar", JSON.stringify(this.state.car));
          this.props.history.push("/carForm");
        }
      );
    } else {
      this.setState({});
    }
  };

  useStyles = () =>
    makeStyles(theme => ({
      button: {
        margin: theme.spacing(1),
        primary: green
      },
      input: {
        display: "none"
      }
    }));

  render() {
    const classes = this.useStyles();

    return (
      <div>
        <Header />
        <CarViewDetail
          image={imgdir + this.state.car.foto1}
          modelName={this.state.car.model}
          nombre={this.state.car.nombre}
          price={this.state.car.precio}
          version={this.state.car.version}
          motor={this.state.car.motor}
          tipo={this.state.car.tipo}
          color={this.state.car.color}
          year={this.state.car.anio}
          gear={this.state.car.transmision}
          titulo1={this.state.car.titulo1}
          texto1={this.state.car.descripcion1}
          titulo2={this.state.car.titulo2}
          texto2={this.state.car.descripcion2}
          titulo3={this.state.car.titulo3}
          texto3={this.state.car.descripcion3}
          chasis={this.state.car.chasis}
          handleReservar={this.handleReservar}
        />
        {isMobile ? null : (
          <CarViewCircles
            version={this.state.car.version}
            motor={this.state.car.motor}
            tipo={this.state.car.tipo}
            color={this.state.car.color}
            year={this.state.car.anio}
            gear={this.state.car.transmision}
          />
        )}
        {isMobile ? null : (
          <CarViewTextDetail
            titulo1={this.state.car.titulo1}
            texto1={this.state.car.descripcion1}
            titulo2={this.state.car.titulo2}
            texto2={this.state.car.descripcion2}
            titulo3={this.state.car.titulo3}
            texto3={this.state.car.descripcion3}
          />
        )}
        {isMobile ? null : (
          <CarGallery
            className="CarGallery"
            images={[
              this.state.image0,
              this.state.image1,
              this.state.image2,
              this.state.image3,
              this.state.image4,
              this.state.image5,
              this.state.image6
            ]}
          />
        )}
        {isMobile ? null : <Footer />}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    car: state.carsReducer.car
  };
};

export default connect(mapStateToProps)(CarView);
